import { LotteryTask } from "../../../core/_shared/models/task.model";
import { DbListBase } from "./db-list-base";
import { DbObjectBase } from "./db-object-base";
import { LotteryCheck } from "../../../core/_shared/models/lottery-check.model";
import { ICollectionReference } from '../database-cast/IDatabase';


export class DbCustomerLotteryBetCheck extends DbObjectBase<LotteryCheck>
{
    constructor(id: string, collection: ICollectionReference)
    {
        super(id,collection);
    }
}

// export class DbCustomerLotteryTotalBetCheck extends DbObjectBase<LotteryCheck>
// {
//     constructor(id: string, collection: ICollectionReference)
//     {
//         super(id,collection);
//     }
// }

// export class DbCustomerLotteryTotalBetChecks extends DbListBase<LotteryCheck> {
  
//     public   getCheck(id: string): DbCustomerLotteryBetCheck {
//       return new DbCustomerLotteryTotalBetCheck(id,this._collection);
//     }
  
  
//       constructor(collection: ICollectionReference) {
//           super(collection);
  
//       }

//     }
export class DbCustomerLotteryBetChecks extends DbListBase<LotteryCheck> {
  
  public   getCheck(id: string): DbCustomerLotteryBetCheck {
    return new DbCustomerLotteryBetCheck(id,this._collection);
  }


    constructor(collection: ICollectionReference) {
        super(collection);

    }


    public AddCheck(task: LotteryCheck): Promise<LotteryCheck> {

        let promise = new Promise<LotteryCheck>((resolve, reject) => {


            let objTask =JSON.parse( JSON.stringify(task));

        

            this._collection.add(objTask)
                .then(docReference => {
             
                    task.id = docReference.id;
                    resolve(task);
                }).
                catch(error => {

             
                    reject(error);

                });
        });


        return promise;
    }


}